// Local Deps
import { makeGraphQLRequest } from '../utils/requestUtils';

export async function loginServices() {
  // Format Mutation
  const query = `mutation loginServices { loginServices { status } }`;

  const response = await makeGraphQLRequest({
    query,
  });

  return response;
}

export async function logoutServices(email) {
  // Format Query
  const query = `mutation logoutServices($email: String) { logoutServices (email: $email) { status } }`;

  // Variables
  const variables = { email };

  const response = await makeGraphQLRequest({
    query,
    variables,
    authCheck: false,
  });
  return response;
}



// WEBPACK FOOTER //
// ./src/graphql/serviceAuthentication.js